import {
  DETAILS_FORM_AGREEMENTS_MARKETING_SET,
  DETAILS_FORM_AGREEMENTS_MARKETING_TOGGLE
} from 'src/app/redux/actions/registration/account/accountFormAgreementsMarketing';
import mapCheckedAgreements from 'src/app/api/mapCheckedAgreements';


const initialState = {
  agreements: []
};

const accountFormAgreementsReducer = (state = initialState, action = {}) => ({
  [DETAILS_FORM_AGREEMENTS_MARKETING_SET]: () => ({ ...state, ...action.payload }),
  [DETAILS_FORM_AGREEMENTS_MARKETING_TOGGLE]: () => ({
    ...state,
    agreements: state.agreements
      .map(mapCheckedAgreements(action))
  })
}[action.type] || (() => state))();


export default accountFormAgreementsReducer;
